import React from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ErrorState({
  title = "Something went wrong",
  description = "We couldn't load this content. Please try again.",
  error,
  onRetry,
  testId = "error-state",
}) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center justify-center rounded-3xl border border-destructive/20 bg-destructive/5 px-6 py-20 text-center"
    >
      <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-destructive/10 text-destructive">
        <AlertTriangle className="h-7 w-7" />
      </div>
      <h3 className="font-heading text-xl font-bold tracking-tight text-foreground">
        {title}
      </h3>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">
        {error?.message || description}
      </p>
      {onRetry && (
        <Button
          data-testid="error-state-retry"
          onClick={onRetry}
          variant="outline"
          className="mt-6 gap-2 rounded-full"
        >
          <RotateCcw className="h-4 w-4" />
          Try again
        </Button>
      )}
    </div>
  );
}

export default ErrorState;
